import React, { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { KeyRound, Loader2, Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";

export const ChangePassword = ({ onDone }) => {
  const [f, setF] = useState({ senha_atual: "", nova_senha: "", confirmar: "" });
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));
  const weak = f.nova_senha.length > 0 && f.nova_senha.length < 8;
  const mismatch = f.confirmar.length > 0 && f.confirmar !== f.nova_senha;
  const disabled = loading || !f.senha_atual || f.nova_senha.length < 8 || f.confirmar !== f.nova_senha;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/change-password", { senha_atual: f.senha_atual, nova_senha: f.nova_senha });
      toast.success("Senha alterada com sucesso!");
      onDone?.();
      setF({ senha_atual: "", nova_senha: "", confirmar: "" });
    } catch (err) { toast.error(err.response?.data?.detail || "Erro ao alterar senha"); }
    finally { setLoading(false); }
  };

  const T = show ? "text" : "password";
  return (
    <form onSubmit={submit} className="mt-8 border-t pt-6 space-y-4 max-w-md" data-testid="change-password-form">
      <div className="flex items-center justify-between">
        <h3 className="font-bold flex items-center gap-2"><KeyRound className="w-4 h-4 gold-text" /> Alterar senha</h3>
        <button type="button" onClick={() => setShow((s) => !s)} className="text-xs text-slate-500 flex items-center gap-1" data-testid="pw-toggle-show">
          {show ? <EyeOff className="w-3.5 h-3.5" /> : <Eye className="w-3.5 h-3.5" />} {show ? "Ocultar" : "Mostrar"}
        </button>
      </div>
      <div className="space-y-1"><Label className="text-xs">Senha atual</Label>
        <Input type={T} value={f.senha_atual} onChange={set("senha_atual")} autoComplete="current-password" data-testid="pw-current" /></div>
      <div className="space-y-1"><Label className="text-xs">Nova senha (mín. 8 caracteres)</Label>
        <Input type={T} value={f.nova_senha} onChange={set("nova_senha")} autoComplete="new-password" data-testid="pw-new" className={weak ? "border-red-300" : ""} />
        {weak && <p className="text-xs text-red-500">Mínimo de 8 caracteres.</p>}</div>
      <div className="space-y-1"><Label className="text-xs">Confirmar nova senha</Label>
        <Input type={T} value={f.confirmar} onChange={set("confirmar")} autoComplete="new-password" data-testid="pw-confirm" className={mismatch ? "border-red-300" : ""} />
        {mismatch && <p className="text-xs text-red-500">As senhas não coincidem.</p>}</div>
      <Button type="submit" disabled={disabled} className="bg-gold hover:bg-[hsl(var(--gold-hover))] text-black font-semibold" data-testid="pw-submit">
        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Salvar nova senha"}
      </Button>
    </form>
  );
};
